export default "__VITE_ASSET__BJyEHRkF__"